import { FC, useContext } from "react";
import {
  Box,
  createStyles,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";

import { Button, ListingsGrid } from "components";
import { AppContext } from "contexts";
import { navigateTo } from "lib/helpers";
import * as routes from "routes";
import { InventoryListing } from "services/inventory/types";
import theme, { Theme } from "theme";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontWeight: 700,
      fontSize: "3.5rem",
      marginBottom: theme.spacing(5),
    },
    centeredTitle: {
      fontWeight: 700,
      fontSize: "2.3rem",
      marginBottom: theme.spacing(8),
      textAlign: "center",
    },
  }),
);

type ListingSectionButton = { label: string; path: string };

export interface ListingSectionProps {
  listings: InventoryListing[];
  isSecondarySection: boolean | null;
  title: string;
  button: ListingSectionButton;
}

const ListingSection: FC<ListingSectionProps> = ({
  listings,
  title,
  button,
  isSecondarySection,
}) => {
  const classes = useStyles();
  const { user } = useContext(AppContext);

  return (
    <Grid
      container
      direction="column"
      style={{ marginBottom: theme.spacing(10) }}
    >
      <Box>
        <Typography
          variant="h1"
          className={isSecondarySection ? classes.centeredTitle : classes.title}
        >
          {title}
        </Typography>
      </Box>
      <ListingsGrid
        listings={listings}
        prevUrl={routes.overview()}
        userId={user?.userId}
        refetchOnModalClose={!!user}
      />
      <Box display="flex" justifyContent="center" marginTop={5}>
        <Button
          style={{
            fontSize: "1.125rem",
            maxWidth: "440px", // match ListingGridItem
            height: "50px",
          }}
          fullWidth
          variant={isSecondarySection ? "contained" : "outlined"}
          onClick={() => navigateTo(button.path)}
        >
          {button.label}
        </Button>
      </Box>
    </Grid>
  );
};

export default ListingSection;
